import { render, staticRenderFns } from "./HistogramTabs.vue?vue&type=template&id=c6369742&scoped=true"
import script from "./HistogramTabs.vue?vue&type=script&lang=js"
export * from "./HistogramTabs.vue?vue&type=script&lang=js"
import style0 from "./HistogramTabs.vue?vue&type=style&index=0&id=c6369742&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6369742",
  null
  
)

export default component.exports